import React, { useState } from "react";

import AddIcon from "@mui/icons-material/Add";
import { Button, IconButton, Stack } from "@mui/material";
import { RoleComponentGuard } from "components/guards";
import { FilesPickerModal } from "components/modals/Files-picker/FilesPicker";
import { LookThroughStatusPrompt } from "components/Prompts/LookThroughStatusPrompt";
import { MaterialTooltip } from "components/tooltips/MaterialTooltip";
import { useDevice, usePrompt } from "hooks";
import { useDealActions } from "store";
import { IFile, IInvestmentDetailField } from "store/types";

import { RoleName } from "../../constants";
import { AddCompanyDrawer } from "./Add-company-drawer/AddCompanyDrawer";

interface IInvestmentDetailActionsProps {
  dealId: number;
  columns: IInvestmentDetailField[];
  onChartsRefetch: () => void;
  onTableRefetch: () => void;
}

export const InvestmentDetailActions: React.FC<IInvestmentDetailActionsProps> = ({
  dealId,
  columns,
  onChartsRefetch,
  onTableRefetch
}) => {
  const { isMobile } = useDevice();
  const openPrompt = usePrompt();
  const { createInvestmentDetailFromAIAction } = useDealActions();
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [filesPickerModalOpen, setFilesPickerModalOpen] = useState(false);

  const filesPickerSubmit = async ({
    filesIds = [],
    attachments
  }: {
    filesIds?: number[];
    files?: IFile[];
    attachments: File[];
  }) => {
    const promise = createInvestmentDetailFromAIAction({
      file_ids: filesIds,
      files: attachments,
      dealId
    });
    //need to handle error before opening the prompt
    promise.catch(() => {});
    setFilesPickerModalOpen(false);
    openPrompt({
      componentType: "status",
      Component: LookThroughStatusPrompt,
      statusTitle: "Look Through extraction",
      props: {
        promise,
        dealId,
        onRefetch: onTableRefetch
      }
    });
  };

  return (
    <RoleComponentGuard availableRoles={[RoleName.Admin, RoleName.Analyst]}>
      <Stack direction="row" gap="8px" alignItems="center">
        {isMobile ? (
          <MaterialTooltip isShow placement="top" title="Add company">
            <IconButton
              sx={{ width: "24px", height: "24px", padding: 0, backgroundColor: "#071F35", color: "white" }}
              onClick={() => setIsDrawerOpen(true)}
            >
              <AddIcon sx={{ fontSize: "18px" }} />
            </IconButton>
          </MaterialTooltip>
        ) : (
          <Button
            variant="contained"
            sx={{ backgroundColor: "#071F35", minHeight: "24px", height: "24px" }}
            onClick={() => setIsDrawerOpen(true)}
          >
            Add Manually Underlying Assets
          </Button>
        )}
        <MaterialTooltip isShow placement="top" title="Select a financial of a private equity fund.">
          <Button
            variant="contained"
            sx={{ backgroundColor: "#071F35", minHeight: "24px", height: "24px" }}
            onClick={() => setFilesPickerModalOpen(true)}
          >
            Select a Financial Statement
          </Button>
        </MaterialTooltip>
      </Stack>
      <AddCompanyDrawer
        columns={columns}
        open={isDrawerOpen}
        onClose={() => setIsDrawerOpen(false)}
        refetch={() => {
          onChartsRefetch();
          onTableRefetch();
        }}
      />
      <FilesPickerModal
        filesPickerModalOpen={filesPickerModalOpen}
        onClose={() => setFilesPickerModalOpen(false)}
        currentFiles={[]}
        filesPickerSubmit={filesPickerSubmit}
        title="Ask Ai"
        workspaceTitle="Select or Upload Files"
        singleFileSelection
        dealId={dealId}
      />
    </RoleComponentGuard>
  );
};
